import _ from 'lodash';
import { orgId, Ajax } from 'utils';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypes';
import * as helpAndAnswerActions from '../actions/helpAndAnswerActions';

export function* getHelpAndAnswer(action) {
  try {
    const { type } = action.payload.data;
    const url = `/${orgId}/helpAndAnswer?type=${type}`;
    const { data: result } = yield call(Ajax.get, url);
    const content = _.get(result, 'content', '');
    const payload = {
      content,
      type,
    };
    yield put(helpAndAnswerActions.getHelpAndAnswer.success(payload));
  } catch (error) {
    yield put(helpAndAnswerActions.getHelpAndAnswer.fail(error));
  }
}

export function* watchGetHelpAndAnswer() {
  yield takeLatest(actionTypes.GET_HELP_AND_ANSWER.ACTION, getHelpAndAnswer);
}
